var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordVisibilityIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mySVG",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18.205,
    viewBox: "0 0 20 18.205",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "visibility_FILL1_wght400_GRAD0_opsz24_4_",
    "data-name": "visibility_FILL1_wght400_GRAD0_opsz24 (4)",
    d: "M50-788.8a3.894,3.894,0,0,0,2.9-1.225A4.106,4.106,0,0,0,54.091-793a4.106,4.106,0,0,0-1.193-2.975A3.894,3.894,0,0,0,50-797.2a3.894,3.894,0,0,0-2.9,1.225A4.106,4.106,0,0,0,45.909-793a4.106,4.106,0,0,0,1.193,2.975A3.894,3.894,0,0,0,50-788.8Zm0-1.68a2.336,2.336,0,0,1-1.739-.735A2.463,2.463,0,0,1,47.545-793a2.464,2.464,0,0,1,.716-1.785A2.337,2.337,0,0,1,50-795.52a2.337,2.337,0,0,1,1.739.735A2.464,2.464,0,0,1,52.455-793a2.463,2.463,0,0,1-.716,1.785A2.336,2.336,0,0,1,50-790.48ZM50-786a10.334,10.334,0,0,1-6.045-1.9A10.766,10.766,0,0,1,40-793a10.766,10.766,0,0,1,3.955-5.1A10.334,10.334,0,0,1,50-800a10.334,10.334,0,0,1,6.045,1.9A10.766,10.766,0,0,1,60-793a10.766,10.766,0,0,1-3.955,5.1A10.334,10.334,0,0,1,50-786Z",
    transform: "translate(-40 800)",
    fill: "rgba(34, 99, 141, 0.5)",
    opacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordVisibilityIcon);
export default __webpack_public_path__ + "static/media/passwordVisibilityIcon.560084d9b79136655807d27c7ef24571.svg";
export { ForwardRef as ReactComponent };